<template>
  <v-item-group
    class="d-flex"
    mandatory
    :value="value"
    @change="$emit('input', $event)"
  >
    <list-tab-item
      v-for="(item, i) in items"
      :key="i"
      :icon="item.icon"
      :count="item.count"
      :value="item.value"
      :selected="item.value === value"
      :disabled="item.disabled"
    />
  </v-item-group>
</template>

<script>
import ListTabItem from './ListTabItem';
export default {
  name: 'ListTabs',
  components: { ListTabItem },
  props: {
    value: {
      type: String,
      default: null,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
